import { IntegrationsList } from '../../routes/_public.chatgpt-for-microsoft-word';
import PromptsListing from '../LandingPromptsListing';

export default function Index({ prompts, title, description }) {
    return (
        <>
            <PromptsListing
                title={title}
                description={description || '100% Free Ai Tools. No Login.'}
                prompts={prompts}
            />
            <IntegrationsList title='Add ChatGPT into' />
        </>
    );
}
